import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import dmIconCircle from '../../assets/dmIconCircle.png'

const ButtonContainer = styled.div`
  display: none;
  position: fixed;
  bottom: 18px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;

  @media only screen and (max-width: 744px) {
    display: block;
  }
`

const StyledButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(270deg, #ff9d74 0%, #ff5e6d 37.4%, #ff4f7e 74.69%, #ff6d90 100%);
  color: white;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  padding: 12px 20px;
  border-radius: 100px;
  text-decoration: none;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08);

  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), linear-gradient(270deg, #ff9d74 0%, #ff5e6d 37.4%, #ff4f7e 74.69%, #ff6d90 100%);
  }

  img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
    border: 2px solid white;
    border-radius: 50%;
  }
`

const DiscoverButton = () => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    const scrollBox = document.querySelector('#scroll-box')
    const postScrollBox = document.querySelector('#posts-scroll-box')

    const handleScroll = () => {
      const scrollBox = document.querySelector('#scroll-box')
      const postScrollBox = document.querySelector('#posts-scroll-box')

      if (!scrollBox && !postScrollBox) return
      if (scrollBox?.scrollTop > 2000 || postScrollBox?.scrollTop > 2000) {
        scrollBox?.removeEventListener('scroll', handleScroll)
        postScrollBox?.removeEventListener('scroll', handleScroll)
        setShowButton(true)
      }
    }

    scrollBox?.addEventListener('scroll', handleScroll)
    postScrollBox?.addEventListener('scroll', handleScroll)

    return () => {
      scrollBox?.removeEventListener('scroll', handleScroll)
      postScrollBox?.removeEventListener('scroll', handleScroll)
    }
  }, [])

  if (!showButton || isAuthenticated) return null

  return (
    <ButtonContainer>
      <StyledButton onClick={() => logEvent('discover_button_clicked')} href="https://decormatters.app.link/jRBbXCsXVQb" target="_blank" rel="noopener noreferrer">
        <img src={dmIconCircle} alt="DecorMatters" />
        Discover more
      </StyledButton>
    </ButtonContainer>
  )
}

export default DiscoverButton
